import { takeLatest } from "redux-saga/effects";
import { logOutUser } from "../reducer";
import { logout } from "../../../utils/helpers";

export function* userLogout() {
  yield logout();
}

export default function* onLogOut() {
  yield takeLatest(logOutUser.type, userLogout);
}
